import React, { useCallback } from 'react'
import cn from 'classnames'
import { useSelector } from 'react-redux'
import * as utils from '@/utils'
import { getMessageById } from '@/models/messages/selectors'
import styles from './styles.module.less'
import dayjs from 'dayjs'
import { Avatar, Tooltip, Button } from 'antd'
import PhotoSwipe from 'photoswipe/dist/photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'

const emojiList = ["微笑", "爱慕", "惊呆", "酷拽", "抠鼻", "流泪", "发怒", "呲牙", "鼾睡", "害羞", "可爱", "晕", "衰", "闭嘴", "机智", "来看我", "灵光一闪", "耶", "捂脸", "打脸", "大笑", "哈欠", "震惊", "送心", "困", "what", "泣不成声", "小鼓掌", "酷", "偷笑", "石化", "思考", "吐血", "可怜", "嘘", "撇嘴", "黑线", "笑哭", "雾霾", "奸笑", "得意", "憨笑", "抓狂", "泪奔", "钱", "吻", "恐惧", "笑", "快哭了", "翻白眼", "互粉", "赞", "鼓掌", "谢谢", "OK", "加油", "爱心", "kiss", "去污粉", "666", "玫瑰", "胡瓜", "啤酒", "我想静静", "委屈", "舔屏", "鄙视", "飞吻", "再见", "紫薇别走", "听歌", "求抱抱", "周冬雨的凝视", "马思纯的微笑", "吐舌", "呆无辜", "看", "白眼", "熊吉", "骷髅", "黑脸", "吃瓜群众", "绿帽子", "汗", "摸头", "皱眉", "擦汗", "红脸", "尬笑", "做鬼脸", "强", "如花", "吐", "惊喜", "敲打", "奋斗", "吐彩虹", "大哭", "比心", "碰拳", "击掌", "左上", "握手", "抱拳", "18禁", "刀", "+1", "V5", "给力", "伤心", "屎", "礼物", "蛋糕", "撒花", "不看", "炸弹"]

function ParsedText({ text }) {
  const reg = /\[\:([^\]]+)\]/g

  return text.split(reg).map((elem, i) => {
    if (!elem) return null

    const idx = emojiList.indexOf(elem)
    if (idx !== -1) {
      const url = process.env.PUBLIC_URL + `/emoji/${idx + 1}.png`

      return (
        <Tooltip key={i} title={emojiList[idx]}>
          <img
            alt={emojiList[idx]}
            className={styles.emoji}
            src={url} />
        </Tooltip>
      )
    }
    return <span key={i}>{elem}</span>;
  });
}

export default function Message({ id, readOnly, onWithdraw }) {
  const message = useSelector(getMessageById(id))

  if (message.get('from_type') === 'system') {
    const sysMsg = utils.formatSystemMessage(message)

    if (!sysMsg) {
      return null
    }

    return (
      <div className={styles.systemMsg}>
        <span className={styles.time}>{dayjs(message.get('createdAt')).format('YYYY-MM-DD HH:mm:ss')}</span>
        <span className={styles.text} dangerouslySetInnerHTML={{ __html: sysMsg }}></span>
      </div>
    );
  }

  const side = ((
    process.env.APP_MODE === 'tenant' && message.get('from_type') === 'staff') ||
    (process.env.APP_MODE === 'manager' && message.get('from_type') === 'manager'))
    ? 'right'
    : 'left'

  const size = utils.calSize(
    message.getIn(['image', 'dimensions', 'width']),
    message.getIn(['image', 'dimensions', 'height'])
  )
  const previewImage = useCallback(() => {
    const pswpElement = document.querySelectorAll('.pswp')[0];


    const items = [{
      src: message.getIn(['image', 'url']),
      w: message.getIn(['image', 'dimensions', 'width']),
      h: message.getIn(['image', 'dimensions', 'height'])
    }]

    const options = {
      index: 0,
      history: false,
      tapToClose: false
    };

    // Initializes and opens PhotoSwipe
    const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
  })

  return (
    <div className={cn(styles.message, styles[side])}>
      <Avatar
        size={48}
        className={styles.avatar}
        src={message.getIn(['createBy', 'avatar'])} />
      <div className={styles.messageCon}>
        <div className={styles.username}>
          {message.getIn(['createBy', 'name'])}
        </div>
        <div className={styles.messageBody}>
          {
            message.get('message_type') === 'text' && (
              <ParsedText text={message.get('text')} />
            )
          }
          {
            message.get('message_type') === 'image' && (
              <img
                onClick={previewImage}
                src={message.getIn(['image', 'url']) + '?x-oss-process=image/resize,w_400/format,webp'}
                width={size[0]}
                height={size[1]} />
            )
          }
          <span className={styles.createdTime}>
            {dayjs(message.get('createdAt')).format('MM-DD HH:mm')}
          </span>
        </div>
        {!readOnly && (dayjs().diff(dayjs(message.get('createdAt')), 'minute') <= 10 && side == 'right') &&
          <div className={styles.messagebtns} style={{ paddingTop: '5px' }}>
            <Button type="primary" size="small" ghost onClick={() => { onWithdraw(id) }}>
              撤回
            </Button>
          </div>}
      </div>
    </div>
  );
}
